import { render, staticRenderFns } from "./ExaminationSituation.vue?vue&type=template&id=07e3481b&scoped=true&"
import script from "./ExaminationSituation.vue?vue&type=script&lang=js&"
export * from "./ExaminationSituation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e3481b",
  null
  
)

export default component.exports